// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestProtocolOperationTemplateId } from './HarvestProtocolOperationTemplate';
import { harvestOperationTemplateAttributeId } from './HarvestOperationTemplateAttribute';
import { invItemId } from './InvItem';
import { z } from 'zod';
export const harvestProtocolOpParamSettingId = (z.number());
export const harvestProtocolOpParamSetting = z.object({
    id: harvestProtocolOpParamSettingId,
    protocol_op_template_id: harvestProtocolOperationTemplateId,
    template_attribute_id: harvestOperationTemplateAttributeId,
    number_value: z.string().nullable(),
    measurement_unit: z.string().nullable(),
    inventory_item_id: invItemId.nullable(),
    check_value: z.boolean().nullable(),
    timestamp_value: z.date().nullable(),
    note: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    text_value: z.string().nullable(),
});
export const harvestProtocolOpParamSettingInitializer = z.object({
    id: harvestProtocolOpParamSettingId.optional(),
    protocol_op_template_id: harvestProtocolOperationTemplateId,
    template_attribute_id: harvestOperationTemplateAttributeId,
    number_value: z.string().optional().nullable(),
    measurement_unit: z.string().optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    timestamp_value: z.date().optional().nullable(),
    note: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    text_value: z.string().optional().nullable(),
});
export const harvestProtocolOpParamSettingMutator = z.object({
    id: harvestProtocolOpParamSettingId.optional(),
    protocol_op_template_id: harvestProtocolOperationTemplateId.optional(),
    template_attribute_id: harvestOperationTemplateAttributeId.optional(),
    number_value: z.string().optional().nullable(),
    measurement_unit: z.string().optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    timestamp_value: z.date().optional().nullable(),
    note: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    text_value: z.string().optional().nullable(),
});
//# sourceMappingURL=HarvestProtocolOpParamSetting.js.map